import useEntity from "../../hooks/useCordwood";
import CordwoodDetail from "../../components/cordwood/CordwoodDetail/CordwoodDetail";
import CordwoodScoped from "../../components/cordwood/CordwoodDetail/CordwoodScoped";
import CordwoodTabs from "../../components/cordwood/CordwoodDetail/CordwoodTabs";
import { useGetCordwoodQuery } from "../../apis/Cordwood.api";
import { PrimaryCordwood } from "../../types/models/Cordwood";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CordwoodDetailPage = () => {

    useTitle(t`Details Cordwood`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { cordwoodId: id } = useParams();

    const { data, refetch } = useGetCordwoodQuery(PrimaryCordwood.fromPath(id))
    const { deleteCordwood } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteCordwood(data, '..')
    }, [data, deleteCordwood])

    if (id === 'scoped') {
        return (<CordwoodScoped/>)
    }

    return (
        <Box data-testid="Cordwood-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <CordwoodDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Cordwoods/update/view'
        ) ||
false) &&
                        !(data?.shipmentId)
                        &&
                        <Button size="small" variant="outlined" data-testid="Cordwood-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Cordwoods/delete/view'
        ) ||
false) &&
                        !(data?.shipmentId)
                        &&
                        <Button size="small" color="error" variant="outlined" data-testid="Cordwood-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <CordwoodTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default CordwoodDetailPage;
